var PD = PD || {};
PD.homepage = PD.homepage || {};

PD.homepage = (function(homepage) {

  homepage.init = function(contactEmail, contactPhone){
    // Initialize contact information:
    // PD.homepage.Support.setContactInformation(contactEmail, contactPhone);

    // Initialize Forms and handle form requests
    // PD.homepage.Support.init();
    // PD.homepage.Newsletter.init();

    // click
    document.addEventListener("click", function(e){
      var $elm = $(e.target);
      // make sure we only show one popover at a time
      if (popovers.length && !$elm.closest(".popover").length) {
        popovers.map(function(v){
          $(v).popover("hide");
          // why isn't this done when hiding... c'mon Bootstrap
          ($(v).data("bs.popover") || {inState: {}}).inState.click = false;
        });
      }
    });

    var popovers = [];
    $(document.body).on("shown.bs.popover", function(e){
      popovers.push(e.target);
    });
    $(document.body).on("hide.bs.popover", function(e){
      var ind = popovers.indexOf(e.target);
      if (ind !== -1) {
        popovers.splice(ind,1);
      }
    });


    _handleScrollTo()
  };

  homepage.getGeoLocation = function() {
    if (document.cookie) {
      geoStartIndex = document.cookie.indexOf('geo_location=') + 13;
      var geoloc = document.cookie.substring(geoStartIndex, document.cookie.indexOf(";", geoStartIndex));

      if (geoloc !== "")
        return geoloc;
    }

    return "dk";
  }

  // Determine default phone code based on TLD or location:
  homepage.getPhoneCode = function () {
    var location = ((typeof DEFAULT_LOCATION === "string")? DEFAULT_LOCATION : PD.homepage.getGeoLocation()).toLowerCase();

    var locationToPhoneCode = {
      "at" : "+43",
      "ch" : "+41",
      "de" : "+49",
      "dk" : "+45",
      "gb" : "+44",
      "ie" : "+353",
      "is" : "+354",
    };

    return locationToPhoneCode[location] ? locationToPhoneCode[location] : "+45";
  };

  function _handleScrollTo() {
    // Handle URL scroll to paramter:
    var scrollTo = PD.utils.getUrlParam('scrollTo', 'hash');
    _scrollToElement(scrollTo);
    PD.utils.clearUrlParam('scrollTo', 'hash');

    // Handle in page scroll to elements:
    $("[data-scroll-to]").on('click', function() {
      _scrollToElement($(this).attr("data-scroll-to"));
    });
  }

  function _scrollToElement(label) {
    var $scrollToElement = label && $("[data-label='"+label+"']");
    if ($scrollToElement && $scrollToElement.length > 0) {
      $('html, body').animate({
        scrollTop: $scrollToElement.offset().top - (132 + 80) // Account for menu offset
      },
      600,
      "swing",
      function() {
        $scrollToElement.addClass("highlight-once");
      });
    }
  }

  // mobile sidebar
  function closeMobile() {
    $(".navbar__mobile").removeClass("active");
    $(document.body).removeClass("body--has-sidebar");
  }
  $(".navbar__mobile-close-btn").click(function(){
    closeMobile();
  });
  $(".navbar__mobile-toggle").click(function(){
    $(".navbar__mobile").toggleClass("active");
    $(document.body).toggleClass("body--has-sidebar");
  });

  return homepage;

})(PD.homepage || {});